import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FundTransferDetails {
  amount?: string;
  remark?: string;
  saveAsBeneficiary?: boolean;
  transactionFee?: string;
  recipient?: string;
}
interface FundWalletState {
  selectedOption: string | null;
  saveAsDefault: boolean;
  fundTransferDetails: FundTransferDetails | any;
}

const initialState: FundWalletState = {
  selectedOption: null,
  saveAsDefault: false,
  fundTransferDetails: null,
};

const fundWalletSlice = createSlice({
  name: "fundWallet",
  initialState,
  reducers: {
    setSelectedOption: (state, action: PayloadAction<string>) => {
      state.selectedOption = action.payload;
    },
    toggleSaveAsDefault: (state) => {
      state.saveAsDefault = !state.saveAsDefault;
    },
    fundTransfer: (state, action: PayloadAction<FundTransferDetails>) => {
      state.fundTransferDetails = action.payload;
    },
    resetFundWallet: () => initialState,
  },
});

export const {
  setSelectedOption,
  toggleSaveAsDefault,
  resetFundWallet,
  fundTransfer,
} = fundWalletSlice.actions;

export default fundWalletSlice.reducer;
